import { render, staticRenderFns } from "./EditSurvey.vue?vue&type=template&id=2532b834&scoped=true&"
import script from "./EditSurvey.vue?vue&type=script&lang=js&"
export * from "./EditSurvey.vue?vue&type=script&lang=js&"
import style0 from "./EditSurvey.vue?vue&type=style&index=0&id=2532b834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2532b834",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2532b834')) {
      api.createRecord('2532b834', component.options)
    } else {
      api.reload('2532b834', component.options)
    }
    module.hot.accept("./EditSurvey.vue?vue&type=template&id=2532b834&scoped=true&", function () {
      api.rerender('2532b834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/EditSurvey.vue"
export default component.exports